import React, {useEffect} from "react";
import {Card, CardContent, Grid, TextField} from "@mui/material";
import {Controller, useFormContext} from "react-hook-form";
import {PhoneField} from "~/apps/core/ui/PhoneField";
import {useAdmissionCompany} from "~/apps/packages/passes/hooks";
import {Values} from "./PassForm";


export type CompanyFormCardProps = {
    setCompanyDataLoading: (value: boolean) => void
    isCompanyDataLoading: boolean
}


export const CompanyFormCard = ({ isCompanyDataLoading, setCompanyDataLoading }: CompanyFormCardProps) => {
    const {control, setValue, getValues, errors} = useFormContext<Values>();
    const {data, loading} = useAdmissionCompany();

    useEffect(() => {
     if (isCompanyDataLoading !== loading) {
         setCompanyDataLoading(loading)
     }
    }, [loading, isCompanyDataLoading])

    useEffect(() => {
        if (data) {
            const values = getValues();
            const newValues: Partial<Values> = {
                companyName: data.name,
                inn: data.inn,
                chiefPhone: data.chiefPhone,
                chiefFullName: data.chiefFullName
            }

            for (const [fieldName, value] of Object.entries(newValues)) {
                if (!values[fieldName]) {
                    setValue(fieldName as keyof typeof newValues, value, {shouldValidate: true})
                }
            }
        }
    }, [data, getValues, setValue]);

    return (
        <Card>
            <CardContent>
                <Grid container direction="column" spacing={2}>
                    <Grid item>
                        <Controller
                            name="companyName"
                            control={control}
                            rules={{required: true}}
                            render={({onChange, value}) => (
                                <TextField
                                    label="Юр.лицо"
                                    fullWidth
                                    disabled={true}
                                    InputProps={{readOnly: true}}
                                    value={value}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item>
                        <Controller
                            name="inn"
                            rules={{required: true}}
                            control={control}
                            render={({onChange, value}) => (
                                <TextField
                                    label="ИНН"
                                    fullWidth
                                    disabled={true}
                                    InputProps={{readOnly: true}}
                                    value={value}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item>
                        <Controller
                            name="chiefFullName"
                            control={control}
                            rules={{required: "Обязательно для заполнения"}}
                            render={({onChange, value, name, ref}) => (
                                <TextField
                                    label="Руководитель"
                                    fullWidth
                                    placeholder="Иванов Иван Иванович"
                                    inputProps={{maxLength: 128}}
                                    value={value}
                                    onChange={onChange}
                                    error={Boolean(errors?.[name])}
                                    helperText={errors?.[name]?.message}
                                    inputRef={ref}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item>
                        <Controller
                            name="chiefPhone"
                            control={control}
                            rules={{required: "Обязательно для заполнения", minLength: 10}}
                            render={({onChange, value, name, ref}) => (
                                <PhoneField
                                    label="Телефон руководителя"
                                    fullWidth
                                    value={value}
                                    onChange={onChange}
                                    error={Boolean(errors?.[name])}
                                    helperText={errors?.[name]?.message}
                                    inputRef={ref}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}